export const alertsConstants = {
  DETAIL_REQUEST: 'ALERTS_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'ALERTS_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'ALERTS_DETAIL_FAILURE',
  FEEDBACK_REQUEST: 'ALERTS_FEEDBACK_REQUEST',
  FEEDBACK_SUCCESS: 'ALERTS_FEEDBACK_SUCCESS',
  FEEDBACK_FAILURE: 'ALERTS_FEEDBACK_FAILURE',
  CORRECT_REQUEST: 'ALERTS_CORRECT_REQUEST',
  CORRECT_SUCCESS: 'ALERTS_CORRECT_SUCCESS',
  CORRECT_FAILURE: 'ALERTS_CORRECT_FAILURE'
};
